export const DEFAULT_ASPECT_RATIO = 16 / 9;
export const MAX_HEIGHT = 280;
export const LOADER_DELAY = 6 * 1000;
export const EMBED_TYPES = {
    LINK: 'link',
    PHOTO: 'photo',
    RICH: 'rich',
    VIDEO: 'video',
};
export const ROUND_CORNERS = {
    none: '0',
    small: '4px',
    themeDefault: 'THEME_DEFAULT',
};
export const CONSENT_STORAGE_NAME = 'hb-embed-consent';
export const ALLOW_ALL_KEY = '__all__';
export const ALWAYS_PRESENT_PROVIDERS = [
    ['youtube.com', 'YouTube'],
    ['twitter.com', 'Twitter'],
    ['vimeo.com', 'Vimeo'],
];
//# sourceMappingURL=constants.js.map